/**
 * Shared carb / sodium target clamps. Extracted from five inline copies
 * (FuelingSection, JourneySettingsModal, JourneyOverrides, TrainingPlanWizard ×2)
 * so a server-limit change lands in one place (My Training UX audit §5).
 *
 * These mirror the server's accepted ranges. Keep in sync if the API widens
 * them; a mismatch silently truncates user input.
 */

/** Max carb target the engine accepts, g/hr. */
export const CARB_TARGET_MAX = 140;
/** Min positive carb target, g/hr (0 / unset handled by callers). */
export const CARB_TARGET_MIN = 1;
/** Sodium target range, mg/hr. */
export const SODIUM_TARGET_MAX = 2000;
export const SODIUM_TARGET_MIN = 100;

/**
 * Clamp a carb target to the engine's accepted range. A non-positive input
 * means "unset" and returns 0 — callers that model unset as `null` (e.g.
 * per-workout overrides) should map `0 → null` at the edge.
 */
export function clampCarbTarget(n: number): number {
  return n > 0 ? Math.min(CARB_TARGET_MAX, Math.max(CARB_TARGET_MIN, Math.round(n))) : 0;
}

/**
 * Clamp a sodium target to the engine's accepted range. Non-positive → 0
 * ("unset"); callers modelling unset as `null` map `0 → null` at the edge.
 */
export function clampSodiumTarget(n: number): number {
  return n > 0 ? Math.min(SODIUM_TARGET_MAX, Math.max(SODIUM_TARGET_MIN, Math.round(n))) : 0;
}
